const htmlUnescapes = {
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#39;": "'",
};
const reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g;
const reHasEscapedHtml = RegExp(reEscapedHtml.source);

const createPropertyAccessor = (dataObject: Record<string, string>) => {
  return function getPropertyValue(propertyKey: string): string {
    return dataObject == null ? "" : dataObject[propertyKey];
  };
};

const unescapeHtmlChar = createPropertyAccessor(htmlUnescapes);

export const unescape = (string: string): string => {
  return string && reHasEscapedHtml.test(string)
    ? string.replace(reEscapedHtml, unescapeHtmlChar)
    : string;
};
